import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './css/index.css';
import { login } from './lib/allauth';
import FormErrors from './components/FormErrors';
import { useAuthInfo } from './auth/hooks';

export default function Login () {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [response, setResponse] = useState({ fetching: false, content: null });
  const navigate = useNavigate();

  const authInfo = useAuthInfo();
  const isAuthenticated = authInfo?.isAuthenticated ?? false;
  const user = authInfo?.user ?? null;

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/homelogin', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  function submit () {
    setResponse(r => ({ ...r, fetching: true }));

    login({ username, password })
      .then((content) => {
        setResponse(r => ({ ...r, content }));
        if (content?.status === 200 && content?.meta?.is_authenticated) {
          navigate('/homelogin', { replace: true });
        }
      })
      .catch((e) => {
        console.error(e);
        window.alert(e);
      })
      .finally(() => {
        setResponse(r => ({ ...r, fetching: false }));
      });
  }

  if (!authInfo) {
    return <div>Loading…</div>;
  }

  return (
    <>
      <header className="top-bar">
        <div className="logo-section">
          <div className="logo-wrapper">
            <img
              src={require('./img/svk.png')}
              alt="Scoutkåren logo"
              className="logo-img"
            />
            <div className="logo-bubble">
              Välkommen! 🌲
            </div>
          </div>
        </div>

        <nav className="nav-buttons">
          <Link to="/" className="nav-btn secondary">
            Tillbaka till framsidan
          </Link>
        </nav>
      </header>

      <div className="login-page">
        <FormErrors errors={response.content?.errors} />

        {!isAuthenticated ? (
          <form
            className="login-card"
            method="post"
            onSubmit={(e) => { e.preventDefault(); submit(); }}
          >
            <h2>Logga in</h2>

            <div>
              <label>
                Användarnamn
                <input
                  placeholder="Användarnamn"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="login-input"
                />
              </label>
              <FormErrors param="username" errors={response.content?.errors} />
            </div>

            <div>
              <label>
                Lösenord
                <input
                  type="password"
                  placeholder="Lösenord"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="login-input"
                />
              </label>
              <FormErrors param="password" errors={response.content?.errors} />
            </div>

            <button type="submit" className="login-button" disabled={response.fetching}>
              Logga in
            </button>

            

            {response.content?.error && <p className="login-error">{response.content.error}</p>}
          </form>
        ) : (
          <div className="login-card">
            <p>
              Inloggad som <strong>{user?.username}</strong>
            </p>

            <button onClick={() => navigate('/homelogin')} className="login-button">
              Gå till medlemssidan
            </button>

            <button onClick={() => navigate('/logout')} className="login-button logout">
              Logga ut
            </button>
          </div>
        )}
      </div>
    </>
  );
}